"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Combo = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const collapsible_1 = require("@nbc-design/collapsible");
const ArrowRight_1 = require("@nbc-design/icons/lib/web/ArrowRight");
require("./combo.css");
/** A combo is a wrapper component designed to list multiple options within the same group. */
const Combo = ({ id, items, type, dataTest = 'combo-list', border = 'outline', hasLabelWithIcon = false, className, }) => {
    const defaultClass = (0, classnames_1.default)('dsc-combo', border !== 'outline' && `is-border${border[0].toUpperCase() + border.slice(1)}`, hasLabelWithIcon && 'has-labelWithIcon', className);
    const withIconClass = 'has-icon';
    const isDisabled = 'disabled';
    const iconMarkup = ((0, jsx_runtime_1.jsx)(ArrowRight_1.ArrowRight, { name: "arrow-right", className: "dsc-combo__arrowIcon", size: "small" }));
    const [isHoverCollapse, setHoverCollapse] = React.useState(false);
    const [itemsState, setItems] = React.useState(items);
    // type = link
    // TODO: determine target
    const comboLinkItems = itemsState.map((item, i) => {
        const linkClasses = (0, classnames_1.default)('dsc-combo--link', item.icon && withIconClass, item.disabled && isDisabled);
        const keyValue = item.key || `${id}__${i.toString()}`;
        return ((0, jsx_runtime_1.jsx)("li", { className: (0, classnames_1.default)('dsc-combo__item', item.className), children: item.disabled && isDisabled ? ((0, jsx_runtime_1.jsxs)("span", { className: linkClasses, children: [item.children, " ", item.icon && iconMarkup] })) : ((0, jsx_runtime_1.jsxs)("a", { className: linkClasses, href: item.link, "aria-disabled": item.disabled, children: [item.children, " ", item.icon && iconMarkup] })) }, keyValue));
    });
    const ComboLink = () => ((0, jsx_runtime_1.jsx)("ul", { className: defaultClass, "data-test": dataTest, children: comboLinkItems }));
    // type = button
    const comboButtonItems = itemsState.map((item, i) => {
        const key = item.key || `${id}__${i.toString()}`;
        return ((0, jsx_runtime_1.jsx)("li", { className: (0, classnames_1.default)('dsc-combo__item', item.className), children: (0, jsx_runtime_1.jsxs)("button", { className: (0, classnames_1.default)('dsc-combo--btn', item.icon && withIconClass), type: "button", disabled: item.disabled, onClick: item.action, "aria-disabled": item.disabled, children: [item.children, " ", item.icon && iconMarkup] }) }, key));
    });
    const ComboButton = () => ((0, jsx_runtime_1.jsx)("ul", { className: defaultClass, "data-test": dataTest, children: comboButtonItems }));
    const showHover = () => {
        type !== 'list' && setHoverCollapse(true);
    };
    const hideHover = () => {
        type !== 'list' && setHoverCollapse(false);
    };
    React.useEffect(() => {
        setItems(items);
    }, [items]);
    // type = list
    const actionClass = type === 'form' ? 'dsc-combo--form' : '';
    const comboItems = itemsState.map((item, i) => {
        const key = item.key || `${id}__${i.toString()}`;
        const contentMarkup = item?.collapse?.description ? ((0, jsx_runtime_1.jsxs)(collapsible_1.Item, { ...item.collapse, index: key, children: [(0, jsx_runtime_1.jsxs)(collapsible_1.Item.Header, { className: "dsc-combo__collapsibleItem", children: [(0, jsx_runtime_1.jsxs)("div", { className: "dsc-combo__collapseTextContainer", onMouseOver: showHover, onMouseLeave: hideHover, children: [item.children, ' '] }), (0, jsx_runtime_1.jsx)(collapsible_1.Item.Button, { className: "dsc-combo__collapseBtn", children: (0, jsx_runtime_1.jsx)(collapsible_1.Item.ToggleIcons, { ariaLabelOpen: item.collapse.ariaLabelClose, ariaLabelClose: item.collapse.ariaLabelOpen }) })] }), (0, jsx_runtime_1.jsx)(collapsible_1.Item.Body, { className: "dsc-combo__descriptionContainer", children: item.collapse.description })] })) : (item.children);
        return (
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props
        (0, jsx_runtime_1.jsx)("li", { className: (0, classnames_1.default)('dsc-combo__item', actionClass, item.icon && withIconClass, item.disabled && isDisabled, item.collapse && 'is-collapsable', isHoverCollapse && 'is-hoverCollapse', item.className), "aria-disabled": item.disabled, children: contentMarkup }, key));
    });
    const ComboList = () => ((0, jsx_runtime_1.jsx)("ul", { className: defaultClass, "data-test": dataTest, children: comboItems }));
    switch (type) {
        case 'button':
            return ComboButton();
        case 'link':
            return ComboLink();
        default:
            return ComboList();
    }
};
exports.Combo = Combo;
exports.Combo.displayName = 'Combo';
//# sourceMappingURL=combo.js.map